<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="dataInfo.Device_WorkOrderFinishDetails"
          ref="form"
          label-width="120px"
        >
          <el-row>
            <el-col
              :span="8"
              v-if="dataInfo.device_WorkOrder.WorkOrderType === '0'"
            >
              <el-form-item label="运行时长" prop="RunTime">
                <el-input
                  v-model="dataInfo.Device_WorkOrderFinishDetails.RunTime"
                  placeholder="运行时长"
                  :disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              v-if="dataInfo.device_WorkOrder.WorkOrderType === '0'"
            >
              <el-form-item label="总时长" prop="TotalDuration">
                <el-input
                  v-model="dataInfo.Device_WorkOrderFinishDetails.TotalDuration"
                  :disabled="disabled"
                  placeholder="总时长"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              v-if="dataInfo.device_WorkOrder.WorkOrderType === '0'"
            >
              <el-form-item label="巡检状态" prop="InspectionStatus">
                <el-input
                  v-model="
                    dataInfo.Device_WorkOrderFinishDetails.InspectionStatus
                  "
                  :disabled="disabled"
                  placeholder="巡检状态"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="完成日期" prop="ActualDate">
                <el-date-picker
                  v-model="dataInfo.Device_WorkOrderFinishDetails.ActualDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  :disabled="disabled"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="'说明'">
                <div
                  v-html="
                    dataInfo.Device_WorkOrderFinishDetails.InspectionRecords
                  "
                  style="
                    width: 100%;
                    height: 180px;
                    overflow: auto;
                    border: 1px solid #e2e2e2;
                    padding: 10px;
                    background-color: #f5f7fa;
                  "
                ></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="'图片'">
                <div
                  style="height: 200px"
                  v-if="dataInfo.device_WorkOrderImgs.length == 0"
                ></div>
                <el-image
                  class="image-item"
                  v-for="v in dataInfo.device_WorkOrderImgs"
                  :key="v.url"
                  :src="v.url"
                  :preview-src-list="[v.url]"
                ></el-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="评价状态">
                <el-select
                  :disabled="isLog"
                  v-model="dataInfo.device_WorkOrder.EvaluationStatus"
                  placeholder="请选择"
                >
                  <el-option value="不合格"> 不合格 </el-option>
                  <el-option value="合格"> 合格 </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="评价结果">
                <div
                  v-if="isLog"
                  v-html="dataInfo.device_WorkOrder.CompleteDescription"
                  style="
                    width: 100%;
                    height: 200px;
                    overflow: auto;
                    border: 1px solid #e2e2e2;
                    padding: 10px;
                    background-color: #f5f7fa;
                  "
                ></div>
                <quill-editor
                  v-else
                  ref="myQuillEditor"
                  v-model="dataInfo.device_WorkOrder.CompleteDescription"
                  :options="editorOption"
                  style="height: 400px"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="检查">
                <div
                  v-html="dataInfo.device_WorkOrder.AIFaultDescription"
                  style="
                    width: 100%;
                    height: 200px;
                    overflow: auto;
                    border: 1px solid #e2e2e2;
                    padding: 10px;
                    background-color: #f5f7fa;
                  "
                ></div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="footer" v-loading="loading" v-if="!isLog">
        <el-button @click="close">取消</el-button>
        <el-button @click="subData" type="primary">审查保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      loading: false,
      logList: [],
      dataInfo: {
        device_WorkOrder: {},
        Device_WorkOrderFinishDetails: {},
        device_WorkOrderImgs: [],
      },
      drawer: false,
      disabled: true,
      editorOption: {
        theme: 'snow', // 主题
        placeholder: '',
        AIshow: false,
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean', 'link'],
            ], // 自定义工具栏选项
          },
        },
      },
      row: {},
    }
  },
  props: {
    isLog: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  methods: {
    subData() {
      this.$http
        .post('/Base_DeviceTreeManage/Device_WorkOrder/WorkOrderReviewData', {
          Id: this.row.Id,
          AIFaultDescription: this.dataInfo.device_WorkOrder.AIFaultDescription,
          CompleteDescription:
            this.dataInfo.device_WorkOrder.CompleteDescription,
          EvaluationStatus: this.dataInfo.device_WorkOrder.EvaluationStatus,
        })
        .then((res) => {
          if (res.Success) {
            this.$notify.success('审查成功')
            this.close()
            this.$emit('success')
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.title = title
      this.dataInfo = {
        device_WorkOrder: {},
        Device_WorkOrderFinishDetails: {},
        device_WorkOrderImgs: [],
      }
      this.row = row
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderData', {
          id,
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.dataInfo = resJson.Data || {}
            // this.logList = resJson.Data;
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
  overflow-y: auto;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .ql-container {
  height: calc(100% - 80px);
}
.image-item {
  width: 200px;
  height: 200px;
  border: 1px solid #ccc;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
